import { render, staticRenderFns } from "./TenantManagement.vue?vue&type=template&id=5591be69"
import script from "./TenantManagement.vue?vue&type=script&lang=js"
export * from "./TenantManagement.vue?vue&type=script&lang=js"
import style0 from "./TenantManagement.vue?vue&type=style&index=0&id=5591be69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports